import React, { useEffect, useState } from 'react';

const AthenaCheck: React.FC = () => {
  const [athenaStatus, setAthenaStatus] = useState<'loading' | 'ok' | 'fail'>('loading');
  const [athenaMessage, setAthenaMessage] = useState<string>('⌛ Pending check...');
  const [athenaData, setAthenaData] = useState<any>(null);

  useEffect(() => {
    const checkAthena = async () => {
      try {
        const res = await fetch('https://athena-616.ngrok.io/status');
        if (!res.ok) throw new Error(`Bad response: ${res.status} ${res.statusText}`);
        const data = await res.json();
        setAthenaStatus('ok');
        setAthenaData(data);
        setAthenaMessage(data.message || '✅ Connected');
      } catch (err: any) {
        setAthenaStatus('fail');
        setAthenaMessage(err.message || '❌ Error reaching Athena');
      }
    };

    setAthenaStatus('loading');
    checkAthena();
  }, []);

  return (
    <div
      style={{
        marginTop: '2rem',
        padding: '1.5rem',
        backgroundColor: '#1c1c2b',
        borderRadius: '8px',
        maxWidth: '800px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <h2 style={{ color: '#80b0ff', fontSize: '1.25rem', marginBottom: '1rem' }}>
        🤖 Athena-GPT Check
      </h2>

      <div
        style={{
          backgroundColor: '#111',
          border: '1px solid #444',
          borderRadius: '6px',
          padding: '1rem',
          fontFamily: 'ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace',
          color: '#ccc',
          fontSize: '0.9rem',
          whiteSpace: 'pre-wrap',
        }}
      >
        <h3
          style={{
            color:
              athenaStatus === 'loading'
                ? '#ffdd80'
                : athenaStatus === 'ok'
                ? '#80ffb0'
                : '#ff6b6b',
            fontWeight: 'bold',
            marginBottom: '0.75rem',
          }}
        >
          {athenaStatus === 'loading'
            ? '⌛ Connecting to Athena-GPT...'
            : athenaStatus === 'ok'
            ? '✅ Connected to Athena-GPT'
            : '❌ Athena-GPT not reachable'}
        </h3>

        {athenaStatus === 'ok' && athenaData && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <div>
                <strong>Service:</strong> <code>Athena-GPT</code>
              </div>
              <div>
                <strong>Message:</strong> <code>{athenaData.message}</code>
              </div>
              <div>
                <strong>Timestamp:</strong>{' '}
                <code>{new Date(athenaData.timestamp).toLocaleString()}</code>
              </div>
            </div>

            <div
              style={{
                marginTop: '2rem',
                backgroundColor: '#111',
                padding: '1rem',
                borderRadius: '6px',
                border: '1px solid #444',
                color: '#ccc',
                fontSize: '0.95rem',
              }}
            >
              <h3 style={{ color: '#80b0ff', marginBottom: '0.75rem' }}>🔮 Next Steps</h3>
              <ul style={{ paddingLeft: '1.25rem' }}>
                <li>Explore <code>/chat</code> endpoint to send prompts.</li>
                <li>Design agent routing via <code>/intent</code> (future).</li>
                <li>Add authentication/permissions for temple owners.</li>
              </ul>
            </div>
          </>
        )}

        {athenaStatus === 'fail' && (
          <p style={{ color: '#ff6b6b' }}>{athenaMessage}</p>
        )}
      </div>
    </div>
  );
};

export default AthenaCheck;
